import React, {Component} from "react";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as R from "ramda";
import SimpleInput from "../../../../../modules/SimpleInput";
import {config} from "../NOS/config";
import Moment from "moment";

class FakturJualSearch extends Component {
    fieldAwal = this.props.tab === "DGI" ? "tanggalInvoiceMulai" : "startFJDate"
    fieldAkhir = this.props.tab === "DGI" ? "tanggalInvoiceAkhir" : "endFJDate"

    getDataValue(fieldName) {
        return !R.isNil(this.props.state.searchData) && this.props.state.searchData[fieldName]
            ? this.props.state.searchData[fieldName]
            : null;
    }

    render() {
        let {tab, state} = this.props;
        return (
            <FlexView column vAlignContent="center">
                <SimpleDDL
                    id="select_options_nama_cabang"
                    box="search"
                    name={tab === "DGI" ? "mainDealer" : "kodeCabang"}
                    containerclassname="width width-250px"
                    placeholder={tab === "DGI" ? "Main Dealer" : "Nama cabang hak akses"}
                    options={tab === "DGI" ? state.mdOptions : state.cabangOptions}
                    value={tab === "DGI" ? state.mainDealer : state.kodeCabang}
                    onChange={(value, {name}) => this.props.onCabangChange(name, value)}
                />
                <FlexView style={{justifyContent: "space-between"}} vAlignContent="center">
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        <p className="margin-bottom-20px">Periode</p>
                        <SimpleDate
                            id="select_date_startFJDate"
                            name={this.fieldAwal}
                            nextdate
                            date={this.getDataValue(this.fieldAwal)}
                            maxDate={this.getDataValue(this.fieldAkhir)}
                            onChange={(value) => this.props.onValueChange(this.fieldAwal, Moment(value).format("DD-MM-YYYY"))}
                        />
                        <SimpleDate
                            id="select_date_endFJDate"
                            name={this.fieldAkhir}
                            backdate
                            date={this.getDataValue(this.fieldAkhir)}
                            minDate={this.getDataValue(this.fieldAwal)}
                            onChange={(value) => this.props.onValueChange(this.fieldAkhir, Moment(value).format("DD-MM-YYYY"))}
                        />
                        <SimpleButton
                            text="Cari"
                            className="margin-bottom-15px"
                            onClick={this.props.onSubmit}
                        />
                    </FlexView>
                    <FlexView vAlignContent="center" style={{gap: "10px"}}>
                        {this.props.tab === "NOS" && (
                            <>
                                <SimpleDDL
                                    id="select_options_code_name_varian"
                                    placeholder="Pembeli / STNK"
                                    box="search"
                                    containerclassname="width width-250px"
                                    isClearable
                                    options={config.searchOptions}
                                    value={this.props.state.searchData?.key || null}
                                    onChange={(value) =>
                                        this.props.onValueChange("key", value)
                                    }
                                />
                                <SimpleInput
                                    placeholder="Nama konsumen"
                                    readOnly={!this.props.state.searchData?.key}
                                    value={this.props.state.searchData?.value}
                                    onChange={({target}) =>
                                        this.props.onValueChange("value", target.value)
                                    }
                                />
                                <SimpleButton
                                    text="Cari"
                                    className="margin-bottom-15px"
                                    onClick={this.props.onSubmit}
                                />
                            </>
                        )}
                        <SimpleButton
                            category="action_button"
                            onClick={this.props.onManualGetDGIData}
                            className="btn background-red margin-bottom-15px"
                            icon={<span><i className="fa fa-search"></i></span>}
                        />
                        <SimpleButton
                            category="action_button"
                            onClick={this.props.onShowFilter}
                            className="btn background-red margin-bottom-15px"
                            icon={<span><i className="fa fa-qrcode"></i></span>}
                        />
                    </FlexView>
                </FlexView>
            </FlexView>
        );
    }
}

export default FakturJualSearch;